'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./slider.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Slider Component.
 * @param {SliderPropsType} props The new component properties.
 * @param {SliderPropsType} DefaultProps The new component default properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
var Slider = function (_Component) {
    (0, _inherits3.default)(Slider, _Component);

    /**
     * constructor
     * @param  {type} props: SliderPropsType
     * @return {type} -
     */
    function Slider(props) {
        (0, _classCallCheck3.default)(this, Slider);

        // These values are destructured since flow will throw test errors if one of these props are passed
        // as undefined, e.g. <Slider max={undefined} />, the alternative is either type checking everything
        // or disabling flow. None of these solutions are great.
        var _this = (0, _possibleConstructorReturn3.default)(this, (Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call(this, props));

        _initialiseProps.call(_this);

        var _props$max = props.max,
            max = _props$max === undefined ? 100 : _props$max,
            _props$initialValue = props.initialValue,
            initialValue = _props$initialValue === undefined ? 100 : _props$initialValue;

        var startvalue = initialValue || max;

        _this.state = {
            value: startvalue,
            sliderStyle: _this.getSliderStyle(startvalue)
        };
        return _this;
    }

    /**
     * getSliderStyle - returns a style object for the background
     * @param  {number} value: current slider value
     * @param  {number} minValue: min slider value
     * @return {object} style Object
     */


    /*
     * updateValue - updates the value
     * @param  {type} newValue number with the new slider value
     * @return {type} -
     */


    /**
     * handleChange - call updateValue with new value from changeEvent.
     * @param  {event} changeEvent input-range event
     * @return {type} -
     */


    /**
     * renderTicks - render a <ul /> of ticks based on min, max and steps (1 tick for each step)
     * @param  {number} min start number for slider
     * @param  {number} max end number for slider
     * @param  {number} step step between each "number"
     * @param  {number} finalValue extra value at the end.
     * @param  {string} unit string after visible numbers e.g. '%', '£'
     * @return {type} React Component
     */


    (0, _createClass3.default)(Slider, [{
        key: 'render',


        /**
         * render - slider component
         * @return {type} React Component
         */
        value: function render() {
            var _props = this.props,
                _props$min = _props.min,
                min = _props$min === undefined ? 0 : _props$min,
                _props$max2 = _props.max,
                max = _props$max2 === undefined ? 100 : _props$max2,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                _props$step = _props.step,
                step = _props$step === undefined ? 10 : _props$step,
                _props$finalValue = _props.finalValue,
                finalValue = _props$finalValue === undefined ? 0 : _props$finalValue,
                isDisabled = _props.isDisabled,
                id = _props.id,
                _props$unit = _props.unit,
                unit = _props$unit === undefined ? '' : _props$unit;
            // return null if min is bigger than max (bad data)

            if (min > max) return null;
            var classNames = (0, _classnames2.default)('slider', className);
            return (0, _jsx3.default)('div', {
                className: classNames,
                id: id
            }, void 0, (0, _jsx3.default)('input', {
                id: 'slider',
                type: 'range',
                min: min,
                max: finalValue && finalValue !== max ? max + step : max,
                step: step,
                value: this.state.value,
                onChange: this.handleChange,
                style: this.state.sliderStyle,
                disabled: isDisabled
            }), (0, _jsx3.default)('ul', {
                className: 'slider__ticks'
            }, void 0, this.renderTicks(min, max, step, finalValue, unit)));
        }
    }]);
    return Slider;
}(_react.Component);
// css


var _ref2 = (0, _jsx3.default)('div', {
    className: 'slider__tick slider__tick--large'
});

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.getSliderStyle = function (value) {
        var _props2 = _this2.props,
            _props2$min = _props2.min,
            min = _props2$min === undefined ? 0 : _props2$min,
            _props2$max = _props2.max,
            max = _props2$max === undefined ? 100 : _props2$max,
            _props2$step = _props2.step,
            step = _props2$step === undefined ? 10 : _props2$step,
            _props2$finalValue = _props2.finalValue,
            finalValue = _props2$finalValue === undefined ? 0 : _props2$finalValue,
            _props2$fillColour = _props2.fillColour,
            fillColour = _props2$fillColour === undefined ? '#00afff' : _props2$fillColour,
            _props2$backgroundCol = _props2.backgroundColour,
            backgroundColour = _props2$backgroundCol === undefined ? '#f2fbff' : _props2$backgroundCol;
        // if finalValue exists we need to extend the range by 1 "step"

        var range = !finalValue || finalValue === max ? max - min : max + step - min;
        var percentFilled = (value - min) / range * 100;
        return {
            background: 'linear-gradient(to right,\n                ' + fillColour + ' ' + percentFilled + '%,\n                ' + backgroundColour + ' ' + percentFilled + '%)'
        };
    };

    this.updateValue = function (newValue) {
        var _props3 = _this2.props,
            _props3$max = _props3.max,
            max = _props3$max === undefined ? 100 : _props3$max,
            _props3$step = _props3.step,
            step = _props3$step === undefined ? 10 : _props3$step,
            _props3$finalValue = _props3.finalValue,
            finalValue = _props3$finalValue === undefined ? 0 : _props3$finalValue,
            _props3$onChange = _props3.onChange,
            onChange = _props3$onChange === undefined ? function () {} : _props3$onChange;
        // Output value needs to be handled differently if finalValue is provided and it's the final value.

        var outputValue = finalValue && newValue === max + step ? finalValue : newValue;
        _this2.setState({
            value: Number(newValue),
            sliderStyle: _this2.getSliderStyle(newValue)
        });
        onChange(outputValue);
    };

    this.handleChange = function (_ref) {
        var target = _ref.target;

        _this2.updateValue(Number(target.value));
    };

    this.renderTicks = function (min, max, step, finalValue, unit) {
        // Set the first step to min.
        var currStep = min;
        var ticks = [];
        // add values to an array to later map over.
        while (currStep <= max) {
            ticks = ticks.concat(currStep);
            currStep += step;
        }

        // Add an extra tick with the finalValue if finalValue exists
        if (finalValue && finalValue !== max) {
            ticks = ticks.concat(finalValue);
        }
        return ticks.map(function (tickValue, i) {
            // Get the middle value of the slider. E.g. if min = 0, max = 55. The middle value is 27.5
            var middleValue = (max + min) / 2;
            // set isMiddleStep = true if the next tickValue is higher than middle value
            // and the current tickValue is less or equal to middleValue
            // only have a middleStep if there's at least 5 ticks in the slider.
            var isMiddleStep = tickValue + step > middleValue && tickValue <= middleValue && ticks.length >= 5;
            // Only add "large ticks" if the currStep is min, in the middle, or max.
            if (tickValue !== min && tickValue < max && !isMiddleStep ||
            // If finalValue exists and this would normally be max, make it a normal step instead.
            tickValue === max && finalValue && finalValue !== max) {
                return (0, _jsx3.default)('li', {
                    className: 'slider__tick',
                    onClick: function onClick() {
                        return _this2.updateValue(tickValue);
                    }
                }, tickValue + i);
            }
            return (0, _jsx3.default)('li', {
                className: 'slider__large-tick-container',
                onClick: function onClick() {
                    return _this2.updateValue(tickValue);
                }
            }, tickValue + i, _ref2, (0, _jsx3.default)('p', {
                className: 'slider__tick-value'
            }, void 0, tickValue, unit));
        });
    };
};

exports.default = Slider;
//# sourceMappingURL=Slider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/slider/Slider.js
// module id = 603
// module chunks = 0